export const CLOSET_CATEGORIES = ['CLOTHING', 'TOY', 'PROP', 'SETTING'];
export const CLOSET_CATALOG = [
    { key: 'heels', category: 'CLOTHING', label: 'Heels', icon: '👠' },
    { key: 'lingerie', category: 'CLOTHING', label: 'Lingerie', icon: '👙' },
    { key: 'stockings', category: 'CLOTHING', label: 'Stockings', icon: '🧦' },
    { key: 'dress', category: 'CLOTHING', label: 'Dress', icon: '👗' },
    { key: 'schoolgirl', category: 'CLOTHING', label: 'Schoolgirl', icon: '🎀' },
    { key: 'latex', category: 'CLOTHING', label: 'Latex', icon: '🖤' },
    { key: 'vibrator', category: 'TOY', label: 'Vibrator', icon: '📳' },
    { key: 'dildo', category: 'TOY', label: 'Dildo', icon: '🍆' },
    { key: 'wand', category: 'TOY', label: 'Wand', icon: '🪄' },
    { key: 'plug', category: 'TOY', label: 'Plug', icon: '🔌' },
    { key: 'clamps', category: 'TOY', label: 'Clamps', icon: '📎' },
    { key: 'blindfold', category: 'PROP', label: 'Blindfold', icon: '🕶️' },
    { key: 'rope', category: 'PROP', label: 'Rope', icon: '🪢' },
    { key: 'paddle', category: 'PROP', label: 'Paddle', icon: '🏏' },
    { key: 'collar', category: 'PROP', label: 'Collar', icon: '⛓️' },
    { key: 'candles', category: 'PROP', label: 'Candles', icon: '🕯️' },
    { key: 'bed', category: 'SETTING', label: 'Bed', icon: '🛏️' },
    { key: 'shower', category: 'SETTING', label: 'Shower', icon: '🚿' },
    { key: 'bathtub', category: 'SETTING', label: 'Bathtub', icon: '🛁' },
    { key: 'couch', category: 'SETTING', label: 'Couch', icon: '🛋️' },
    { key: 'floor', category: 'SETTING', label: 'Floor', icon: '⬛' },
    { key: 'outdoor', category: 'SETTING', label: 'Outdoor', icon: '🌳' },
];
export const CLOSET_CATALOG_KEYS = CLOSET_CATALOG.map((entry) => entry.key);
export const CLOSET_CATALOG_BY_KEY = Object.fromEntries(CLOSET_CATALOG.map((entry) => [entry.key, entry]));
export function isClosetCatalogKey(value) {
    return value in CLOSET_CATALOG_BY_KEY;
}
//# sourceMappingURL=closet-catalog.js.map